// Overgezet uit naslag/server/imports/api/staticGameData/assetData.ts en
// naslag/server/server/generateData/assetData.ts.
import { Asset } from '../types/assets.js';
import { SparePart } from '../types/storage.js';
import { kloon } from '../hulp.js';
// Titels en teksten zijn letterlijk overgenomen, ook "Mixer" en "test123" bij elke machine:
// die velden werden in het origineel niet getoond.
const getAssetDataStatisch = () => {
    const assets = {};
    assets[Asset.mixer] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 1,
        spareParts: [SparePart.watertoevoerklep, SparePart.meelDoseerder, SparePart.eMotor],
    };
    assets[Asset.vormmachineA] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 0,
        spareParts: [SparePart.aandrijving, SparePart.deegwals, SparePart.eMotor],
    };
    assets[Asset.vormmachineB] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 0,
        spareParts: [SparePart.aandrijving, SparePart.deegwals, SparePart.eMotor],
    };
    assets[Asset.oven] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 2,
        spareParts: [SparePart.thermostaat, SparePart.verwarmingselement, SparePart.infraroodCamera],
    };
    assets[Asset.koeler] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 1,
        spareParts: [SparePart.doorvoerband, SparePart.luchtfilters, SparePart.infraroodCamera],
    };
    assets[Asset.inpakker] = {
        level: 0,
        title: 'Mixer',
        text: 'test123',
        reliability: 0,
        complexity: 2,
        spareParts: [SparePart.flexpicker, SparePart.vacuumGripper, SparePart.eMotor],
    };
    return assets;
};
/**
 * Het ene document uit de collectie `staticGameData.assetData`. Schermen die
 * `AssetDataCollection.findOne()?.assets` lazen, gebruiken `ASSET_DATA.assets` of
 * `getAssetData()`.
 */
export const ASSET_DATA = {
    assets: getAssetDataStatisch(),
};
/** Zoals `AssetDataCollection.find({}).fetch()[0].assets`, als eigen kopie. */
export const getAssetData = () => kloon(ASSET_DATA.assets);
export const getEmptyAssetIncidentMalfunctionData = () => {
    return {
        mixer: {
            malfunction: false,
            incident: true,
            malfunctionBuildUp: 1,
            totalIncidentsAndMalfunctions: {
                incident: 1,
                malfunction: 0,
            },
        },
        vormmachineA: {
            malfunction: false,
            incident: false,
            malfunctionBuildUp: 1,
            totalIncidentsAndMalfunctions: {
                incident: 0,
                malfunction: 0,
            },
        },
        vormmachineB: {
            malfunction: false,
            incident: false,
            malfunctionBuildUp: 1,
            totalIncidentsAndMalfunctions: {
                incident: 0,
                malfunction: 0,
            },
        },
        oven: {
            malfunction: true,
            incident: false,
            malfunctionBuildUp: 2,
            totalIncidentsAndMalfunctions: {
                incident: 0,
                malfunction: 1,
            },
        },
        koeler: {
            malfunction: true,
            incident: false,
            malfunctionBuildUp: 2,
            totalIncidentsAndMalfunctions: {
                incident: 0,
                malfunction: 1,
            },
        },
        inpakker: {
            malfunction: false,
            incident: false,
            malfunctionBuildUp: 1,
            totalIncidentsAndMalfunctions: {
                incident: 0,
                malfunction: 0,
            },
        },
    };
};
/** Begintoestand van de fysieke machines, voor een spel met `fysiek: true`. */
export const physicalData = () => Object.values(Asset).reduce((obj, asset) => {
    const data = {
        rolled: false,
        mechanicLevel: 0,
    };
    return { ...obj, [asset]: data };
}, {});
